import React, { FC, useMemo } from 'react';

import { EvFilters } from '@evinced-private/ui-common';

import omit from 'lodash-es/omit';
import { DEFAULT_UNIT_ID_DISPLAY_NAME } from 'src/common/consts/platformConfigConsts';
import { DEFAULT_PERIOD_OPTION } from 'src/common/helpers/DataFilterHelper';

import { useWebSdkTestsFilters } from '../../hooks/useWebSdkTestsFilters';
import { FilterSectionV2Props, V2Filters } from '../../types/filter-section-v2';
import { FilterSectionCommon } from '../filter-section/shared/FilterSectionCommon';
import { useFilterApplyHandler } from '../filter-section/shared/useFilterApplyHandler';

export const FilterSectionV2: FC<FilterSectionV2Props> = ({
	isFilterOptionsLoading,
	filterOptions,
	filters,
	showRecentTest,
	onShowRecentTestChange,
	showTestPath,
	unitIdDisplayName = DEFAULT_UNIT_ID_DISPLAY_NAME,
	onFilterChange
}) => {
	const { handleApply } = useFilterApplyHandler({
		filterOptionsType: 'v2',
		onFilterChange: onFilterChange
			? (flatFilters: V2Filters) => {
					onFilterChange({
						...flatFilters,
						testPeriod: flatFilters.testPeriod ?? [DEFAULT_PERIOD_OPTION]
					});
				}
			: undefined
	});

	const initialValues = useMemo(
		() => ({
			text: { searchValue: filters?.searchValue },
			select: omit(filters, 'searchValue')
		}),
		[filters]
	);

	// Use shared hook for async loading and filters
	const { filterDefinitions, mergedFilterOptions } = useWebSdkTestsFilters({
		allLabels: filterOptions.labels ?? [],
		selectedLabels: filters?.labels ?? [],
		filterOptions,
		unitIdDisplayName,
		isV2: true
	});

	return (
		<FilterSectionCommon
			isFilterOptionsLoading={isFilterOptionsLoading}
			showRecentTest={showRecentTest}
			onShowRecentTestChange={onShowRecentTestChange}
			showTestPath={showTestPath}
		>
			<EvFilters
				className="data-filters filter-section-v2"
				onApply={handleApply}
				onReset={handleApply}
				initialValues={initialValues}
				isFilterOptionsLoaded={!isFilterOptionsLoading}
				filterOptions={mergedFilterOptions}
				filterDefinitions={filterDefinitions}
				shouldSyncValuesWithAvailableOptions={false}
			/>
		</FilterSectionCommon>
	);
};
